import React from "react";
import HeaderPageItem from "../../../../../custom/HeaderPageItem";
import ActionDialog from "../../../ActionDialog";
import { FormattedMessage } from "react-intl";
import { Box, makeStyles, Typography } from "@material-ui/core";
import HelpIcon from "@material-ui/icons/Help";
import TableChartIcon from "@material-ui/icons/TableChart";
import AssessmentIcon from "@material-ui/icons/Assessment";
import SectionTitle from "../../HelpDialog/SectionTitle";
import TipBox from "../../../TipBox";
import UsersFiltersDescription from "../UserFiltersDescription";
import HelpItemsList from "../../HelpDialog/HelpItemsList";
import TableActionsHelp from "../../HelpDialog/TableActionHelp";

const useClasses = makeStyles((theme) => ({
  filterContainer: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingBottom: theme.spacing(1),
    marginBottom: theme.spacing(2),
    marginLeft: theme.spacing(2),
  },
  section: {
    paddingBottom: theme.spacing(1),
    marginBottom: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
}));

const summaryMessages = [
  "app.report.users.summary.totalUsers.byGroup",
  "app.report.users.summary.totalCustody.byGroup",
  "app.report.users.summary.average.byGroup",
  "app.report.users.summary.avgDuration.byGroup",
];

const HeaderGroupedUserReport = ({ title, userFilters }) => {
  const classes = useClasses();
  const [openDialog, setOpenDialog] = React.useState(false);

  return (
    <>
      <HeaderPageItem
        title={title}
        showBackButton
        useHistoryGoBack
        onMore={() => setOpenDialog(true)}
        IconMore={HelpIcon}
      />
      <ActionDialog
        open={openDialog}
        title={title}
        onClose={() => setOpenDialog(false)}
        maxWidth="md"
        textButtonCancel="app.close"
        enableConfirmButton={false}
      >
        <Box className={classes.section}>
          <Typography
            variant="body1"
            paragraph
          >
            <FormattedMessage id="app.report.users.grouped.description.1" />
          </Typography>
          <Typography
            variant="body1"
            paragraph
          >
            <FormattedMessage id="app.report.users.grouped.description.2" />
          </Typography>
        </Box>

        <UsersFiltersDescription
          userFilters={userFilters}
          classes={classes}
        />

        <Box className={classes.section}>
          <SectionTitle icon={AssessmentIcon}>
            <FormattedMessage id="app.report.users.grouped.section.summary" />
          </SectionTitle>
          <Typography
            variant="body1"
            paragraph
          >
            <FormattedMessage id="app.report.users.grouped.summary.description" />
          </Typography>

          <HelpItemsList messages={summaryMessages} />
          <TipBox>
            <FormattedMessage id="app.report.users.summary.alert" />
          </TipBox>
        </Box>

        <Box className={classes.section}>
          <SectionTitle icon={TableChartIcon}>
            <FormattedMessage id="app.report.users.grouped.section.table" />
          </SectionTitle>

          <Typography
            variant="body1"
            gutterBottom
          >
            <FormattedMessage id="app.report.users.grouped.table.description" />
          </Typography>
        </Box>
        <TableActionsHelp
          showCopy
          showColumns
        />
      </ActionDialog>
    </>
  );
};

export default React.memo(HeaderGroupedUserReport);
